import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { TpaListParams } from '@/lib/api/domains/tpas';
import type { TpaId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/** Consumption layer for TPAs (mirrors providers'/clients' shape). */
export function tpaListQuery(params: TpaListParams) {
  return queryOptions({
    queryKey: keys.tpas.list(params),
    queryFn: () => api.tpas.list(params),
    staleTime: 30_000,
  });
}

export function tpaDetailQuery(tpaId: TpaId) {
  return queryOptions({
    queryKey: keys.tpas.detail(tpaId),
    queryFn: () => api.tpas.get(tpaId),
    staleTime: 30_000,
  });
}
